import { render, staticRenderFns } from "./ExamResult.vue?vue&type=template&id=acf15d0a&"
import script from "./ExamResult.vue?vue&type=script&lang=js&"
export * from "./ExamResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\vsProject\\dsf-product-exam\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('acf15d0a')) {
      api.createRecord('acf15d0a', component.options)
    } else {
      api.reload('acf15d0a', component.options)
    }
    module.hot.accept("./ExamResult.vue?vue&type=template&id=acf15d0a&", function () {
      api.rerender('acf15d0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/views/ExamResult.vue"
export default component.exports